import React from 'react';
import styles from './table.module.scss';
import { withTranslation, Trans } from 'react-i18next';
import TableColumnHeader from './table_column_header.jsx';

class TableHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = { sortFilter: this.props.itemsFilter.sortFilter };
        this.changeSort = this.changeSort.bind(this);
    }

    changeSort(sortPropName, isDescending) {
        let sortFilter = {
            propertyName: sortPropName,
            isDescending: isDescending
        };
        this.setState({ ...this.state, sortFilter: sortFilter });
        this.props.getSortedItems(sortFilter);
    }

    render() {
        const i18n = this.props.i18n;
        let sortFilter = {
            propertyName: '',
            isDescending: false
        }

        if (this.props.itemsFilter.sortFilter) {
            sortFilter = this.props.itemsFilter.sortFilter;
        }
        const _this = this;
        return (
            <thead>
                <tr className={styles.table_header}>
                {
                    this.props.columns.map(function(column, index) {
                        return <TableColumnHeader key={index}
                            sortProperty={column.sortProperty}
                            header={i18n.t(column.header)}
                            isDescending={sortFilter.propertyName === column.sortProperty && sortFilter.isDescending}
                            isDefault={sortFilter.propertyName !== column.sortProperty}
                            onSortDirectionChanged={_this.changeSort}/>;
                    })
                }
                {
                    this.props.isEditable && <th></th>
                }
                {
                    this.props.canBeRemoved && <th></th>
                }
            </tr>
            </thead>
        );
    }
}

export default withTranslation('translantions')(TableHeader);